import { rootApi } from 'root-api'

const api = rootApi
  .enhanceEndpoints({ addTagTypes: ['EMPTY_STATES_ACTIVATION_DATA'] })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchEmptyStatesActivationData: build.query({
        query: ({ fields }) => ({
          url: '/api/empty_states/activation_data',
          params: { fields },
        }),
        providesTags: ['EMPTY_STATES_ACTIVATION_DATA'],
      }),
    }),
  })

export const {
  useFetchEmptyStatesActivationDataQuery,
} = api
